import axios from "axios";
import themain from "@/applibs/themain.js";

// HttpOnly jwt cookie (Domain=.pegasusexchange.id) must be sent to first-party
// backends that authenticate via JWT. A global axios.defaults.withCredentials
// would break third-party APIs (Binance, pgx-pg) that still use
// Access-Control-Allow-Origin: *.

function originOf(url) {
  try {
    return new URL(
      url,
      typeof window !== "undefined" ? window.location.href : "http://localhost"
    ).origin;
  } catch (_) {
    return "";
  }
}

function firstPartyOrigins() {
  return [themain.baseApi, themain.baseSync, themain.baseEvm]
    .map((base) => originOf(base || ""))
    .filter(Boolean);
}

function isCredentialedPgxRequest(config) {
  const requestUrl = config.url || "";
  const absolute = /^https?:\/\//i.test(requestUrl)
    ? requestUrl
    : `${config.baseURL || ""}${requestUrl}`;
  const requestOrigin = originOf(absolute);
  if (!requestOrigin) return false;
  return firstPartyOrigins().indexOf(requestOrigin) !== -1;
}

axios.interceptors.request.use((config) => {
  config.withCredentials = isCredentialedPgxRequest(config);
  return config;
});

export default axios;
